/** AJAX Cart **/


/**
 * Format a number to a specific format
 *
 * @param {Number} number - Value to format
 * @param {Number} precision - Amount of decimal points to show
 * @param {String} thousands - Thousands delimiter
 * @param {String} decimal - Decimal delimiter
 * @returns {String|Number}
 */

function getMoneyFormat() {
  let $settingsObject = $('script[data-section-id="static-header"]');
  let settings = typeof $settingsObject !== "undefined" && $settingsObject ? JSON.parse($settingsObject.html())  :[];
  let moneyFormat =  settings ? settings.currency.money_format : "";
  if(!moneyFormat) {
    moneyFormat = Shopify.money_format;
  }
  return moneyFormat;
}

function formatWithDelimiters(number) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  if (isNaN(number) || !number) {
    return 0;
  }
  var preciseNumber = (number / 100.0).toFixed(precision);
  var parts = preciseNumber.split(thousands);
  var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
  var centsAmount = parts[1] ? decimal + parts[1] : '';
  return dollarsAmount + centsAmount;
}

/**
 * Convert a money value in cents to a formatted currency string
 *
 * @param {Number|String} cents
 * @param {String} format
 * @returns {String}
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  format = typeof format !== "undefined" ? format: '$\{\{amount\}\}';

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2, ',', '.');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, '\'', '.');
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
  }

  return format.replace(placeholderRegex, value);
}

const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

for (let i = 0; i < addToCart.length; i++) {

  addToCart[i].addEventListener('click', function(event) {

    event.preventDefault();
    const formID = this.parentNode.getAttribute('id');
    addProductToCart(formID);

  });

}

function addProductToCart(formID) {


  let form = $("#"+formID);
  let data = form.serialize();

  let productId = formID.replace("product_form_", "")

  productId = parseInt(productId, 10);

  let $atcButton = form.find(".js-ajax-add-to-cart");


  addProductToCartRequest(data, $atcButton, $(".productsErrorMessage-"+productId))
}


$(document).on("click", "form[data-product-form] .js-ajax-add-to-cart", function(e) {

  let formId = $(this).closest('form').attr("id");

  addProductToCart(formId)
});


function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {

      onCartUpdate(cart);


      if (cart.item_count === 0) {


        //cart-checkout-button
        let emptyCartHtml = `
<div class="cartitems-empty">
<div class="cartitems-empty--inner">
<p>You haven&#39;t added any product to the cart. When you do, the list will appear on this page.</p>

<a class="button-primary" href="/collections/all">

<svg aria-hidden="true" focusable="false" role="presentation" width="28" height="26" viewBox="0 10 28 26" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" fill-rule="evenodd" d="M26.15 14.488L6.977 13.59l-.666-2.661C6.159 10.37 5.704 10 5.127 10H1.213C.547 10 0 10.558 0 11.238c0 .68.547 1.238 1.213 1.238h2.974l3.337 13.249-.82 3.465c-.092.371 0 .774.212 1.053.243.31.576.465.94.465H22.72c.667 0 1.214-.558 1.214-1.239 0-.68-.547-1.238-1.214-1.238H9.434l.333-1.423 12.135-.589c.455-.03.85-.31 1.032-.712l4.247-9.286c.181-.34.151-.774-.06-1.144-.212-.34-.577-.589-.97-.589zM22.297 36c-1.256 0-2.275-1.04-2.275-2.321 0-1.282 1.019-2.322 2.275-2.322s2.275 1.04 2.275 2.322c0 1.281-1.02 2.321-2.275 2.321zM10.92 33.679C10.92 34.96 9.9 36 8.646 36 7.39 36 6.37 34.96 6.37 33.679c0-1.282 1.019-2.322 2.275-2.322s2.275 1.04 2.275 2.322z"></path>
</svg>
Continue shopping
</a>                  
</div>
</div>`;

        if($(cartDrawerContent).length) {
          cartDrawerContent.innerHTML = emptyCartHtml;
        }
        // checkoutButton.classList.add('visually-hidden');
        $(".ajax-cart-drawer__subtotal-container").addClass("visually-hidden");
        $(".ajax-cart-drawer__buttons  .edit-cart-button").addClass("visually-hidden");
        $(".ajax-cart-drawer__header").addClass("empty--cart-header");


      } else {

        // checkoutButton.classList.remove('visually-hidden');
        $(".ajax-cart-drawer__subtotal-container").removeClass("visually-hidden");
        $(".ajax-cart-drawer__buttons .edit-cart-button").removeClass("visually-hidden");
        $(".ajax-cart-drawer__header").removeClass("empty--cart-header");


      }

    },
  });
}

function changeItem(line, callback) {
  const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart();
      }

    },
  });
}

function onCartUpdate(cart) {

  if(cart.total_price > 0)
    $(".headerSubtotal").html(formatMoney(cart.total_price , getMoneyFormat()));   
}

function addToCartOk(product) {
  //cartModalContent.innerHTML = product.title + " was added to the cart!";
  //cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
  $(".productsErrorMessage").html("");fetchCart();}

function removeProductFromCart() {
  cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
  // cartModalContent.innerHTML = " The product you are trying to add is out of stock.";
  openAddModal();
  openCartOverlay();
}


function addVariantDetails(cart) {

  cart.items.forEach(function(item) {
    $.ajax({ 
      url: '/products/' + item.handle + '.js', 
      dataType: 'json',
      async: false, 
      success: function(product){ 
        product.variants.forEach(function(variant) {
          if (variant.id == item.variant_id) {
            item["variant"] = variant;
            item["product"] = product;
          }

        });
      },
      error: function(response) {

        item["variant"] = [];
        item["product"] = [];
      }
    });
  });

  return cart;
}/*
cartModalClose.addEventListener('click', function() {
    closeAddModal();
    closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
});
*/

let currenturl = window.location.href;

if(!currenturl.includes("/cart")) {$(document).ready(function(){

    fetchCart();   

  });
}
/** AJAX Cart **/


/*** Ajaxinate Start ***/

'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.3
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
Project lead: George Butter
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    pagination: '.AjaxinatePagination',
    method: 'scroll',
    container: '.AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (typeof this.nextPageLinkElement !== 'undefined') {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;

      $(".products-list-footer").addClass("loading-more-products");
      $(".loading-products-title").removeClass("visually-hidden");

      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];      
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;


      $(".products-list-footer").removeClass("loading-more-products");      
      $(".loading-products-title").addClass("visually-hidden");
      $(".products-list-footer").removeClass("stick-to-products-list");

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};

/*** Ajaxinate End ***/


/* collection sidebar title collase */
$('.productgrid--sidebar-section h3.productgrid--sidebar-title--small~.productgrid--sidebar-item').hide();
$( document ).on( 'click', 'h3.productgrid--sidebar-title--small,h2.productgrid--sidebar-title', function(){
  $(this).next('.productgrid--sidebar-item').toggle();
  $(this).toggleClass("active");
} );



/* increment , decrement */

$( document ).on( 'click', '.minus-icon', function(){
  var $this = $( this ),
      $input = $this.closest( 'div' ).find( 'input' ),
      $val = $input.val();
  if( $val > 0 ) {
    $val = parseInt( $val ) - 1;
    $input.val( $val ).trigger( 'change' );
  }
  return false;
} );

$( document ).on( 'click', '.plus-icon', function(){
  var $this = $( this ),
      $input = $this.closest( 'div' ).find( 'input' ),
      $val = $input.val();
  $val = parseInt( $val ) + 1;
  $input.val( $val ).trigger( 'change' );

  return false;
} );


function initTabs($tabLinks, $tabContentContainer) {


  $($tabLinks+" li").click(function() {
    var n = $(this).attr("data-tab");  	
    changeActiveTab(n,$tabLinks, $tabContentContainer)
  });

}


function changeActiveTab(n, $tabLinks, $tabContentContainer) {
  $($tabLinks+" li").removeClass("tab-active");
  $($tabContentContainer+" .tab-content").addClass("visually-hidden");
  $($tabLinks+" li[data-tab=" + n + "]").addClass("tab-active");
  $($tabContentContainer).find($("#" + n)).removeClass("visually-hidden").addClass("tab-active");    

}

initTabs("ul#product-tab-links", ".product-tabs-content-container");

initTabs("ul#product-variants-tab-links", ".product-variants-tabs-content-container");

$(document).on("click", ".clear-variant-row", function(e) {

  e.preventDefault();

  let $variantsContainer = $(this).closest(".product-line-actions").closest(".productitem"); 

  resetVariantsForms($variantsContainer);
  updateSelectedItems(); 
});
$(document).on("click", ".add-all-to-cart", function(e) {

  e.preventDefault();


  var $selectedProducts = $('input.variant-quantity').filter(function() {
    return parseInt($(this).val(), 10) > 0;
  });

  let data = [];

  for(let i=0; i <  $selectedProducts.length; i++) {

    let $selectedProduct = $($selectedProducts[i]);

    let quantity = parseInt($selectedProduct.val()) || 0;
    let variant_id = $selectedProduct.data("variant-id");

    if(typeof $selectedProduct != "undefined") {

      data.push({

        quantity: quantity,
        id: variant_id

      })
    }
  } 

  if(data.length) {

    addMultipleProductToCart(data, $(this));
  } else {

    scrollTo($(".productsErrorMessage"));
    $(".productsErrorMessage").html("Please select products to add in the cart").removeClass("visually-hidden");
                                    }
                                    });

    function scrollTo($container) {

      $('html, body').animate({
        scrollTop: $container.offset().top
      }, 1000);  

    }
    function addProductToCartRequest(data, $atcButton, $errorContainer) {

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        beforeSend:  function() {

          $atcButton.addClass("processing");
          $(".productsErrorMessage").html("");
        },
        data: data,
        success: function() {

          if( $atcButton.closest( '.upsell-item ' ).length > 0 ) {
            $atcButton.closest( '.upsell-item' ).addClass( 'itemInCart' );
          }

          if($atcButton.hasClass("upsell-popup-enabled") && (!($("#modal-upsell").find(".upsell-item.itemInCart").length === $("#modal-upsell").data("upsell-count") ))) {

            $('#upsellPopup').addClass("show-popup");
            $('body').addClass('has-upsell-popup');    
            fetchCart();

          } else {

            if( $atcButton.closest( '.upsell-item ' ).length > 0 ) {

              fetchCart();
            } else {

              addToCartOk();
            }
          }

        },
        error: function(error) {

          var error = JSON.parse(error.responseText);

          $errorContainer = typeof $errorContainer !== "undefined" && $errorContainer.length ? $errorContainer : $(".productsErrorMessage");

          $errorContainer.html(error.description);
          scrollTo($errorContainer);                  
        },
        complete: function() {

          $atcButton.removeClass("processing");

          if($atcButton.closest(".modal").length)
            $atcButton.closest(".modal").find(".modal-close").click();

        }
      });
    }
    $(document).on("change", ".productlistview--items:not('.cartitems--list') .variant-quantity", function(e) {

      e.preventDefault();

      let $cartItem = $(this).closest(".productgrid--item");

      if(!$cartItem.hasClass("cart-item")) {

        updateSelectedItems($(this));
        updateProductLineTotals($(this));
      }else {

        updateProductLineTotal($(this));
      }
      checkStockErrors($(this));

      $(".productsErrorMessage").html("").addClass("visually-hidden");

    });$(document).on("click", ".product-price-details", function() {

      let  $productLinePriceDetails = $(this).closest(".price-view-details-container").find(".product-line-price-details");
      $productLinePriceDetails.toggleClass("visually-hidden");
      $(this).closest(".price-view-details-container").find(".view-details-arrow").toggleClass("up");

    });

    $(document).on("click", ".js-ajax-add-to-cart-collection", function(event) {

      event.preventDefault();

      const $atcButton = $(event.currentTarget);
      const variantID = $atcButton.attr('data-variant-id');
      const $errorContainer = $(".productsErrorMessage-"+variantID);

      const data = [
        {
          name: 'id',
          value: variantID,
        },
        {
          name: 'quantity',
          value: 1,
        },
      ];

        addProductToCartRequest(data, $atcButton,$errorContainer);

        });

        function checkStockErrors($quantityInput) {

        let inventoryPolicy = $quantityInput.data("inventory-policy");
        let inventoryQuantity = $quantityInput.data("inventory-quantity");
        let quantitySelected = $quantityInput.val();
        quantitySelected = parseInt(quantitySelected, 10) || 0;

        if(inventoryPolicy !== "continue" && quantitySelected > inventoryQuantity) {

        $quantityInput.closest(".product-variants-container").find(".inventory-error").removeClass("visually-hidden")
        $quantityInput.addClass("quantity-error");

        $quantityInput.closest(".variant-item").addClass("variant-item-error");
        $quantityInput.closest(".productitem").addClass("productitem-error");
        $quantityInput.closest(".variant-item").find(".secondary-details").addClass("quantity-error");

        } else {

        $quantityInput.removeClass("quantity-error");
        $quantityInput.closest(".variant-item").removeClass("variant-item-error");
        $quantityInput.closest(".productitem").removeClass("productitem-error");
        $quantityInput.closest(".variant-item").find(".secondary-details").removeClass("quantity-error");
        $quantityInput.closest(".product-variants-container").find(".inventory-error").addClass("visually-hidden")

        }

        }
        function addMultipleProductToCart(data, $button) {

        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        beforeSend:  function() {

        $button.addClass("processing");
        },
        data: {

        items: data
        },
        success: function(cart) {

        resetVariantsForms();
        updateSelectedItems();
        $(".productsErrorMessage").html("").addClass("visually-hidden");

        if( $button.closest( '.upsell-item ' ).length > 0 ) {
        $button.closest( '.upsell-item' ).addClass( 'itemInCart' );
        }

        if($button.hasClass("upsell-popup-enabled") && (!($("#modal-upsell").find(".upsell-item.itemInCart").length === $("#modal-upsell").data("upsell-count") ))) {

        $('#upsellPopup').addClass("show-popup");
        $('body').addClass('has-upsell-popup');
        fetchCart();

        } else {

        if( $button.closest( '.upsell-item ' ).length > 0 ) {

        fetchCart();
        } else {

        scrollTo($(".header-cart"));
        addToCartOk();
        }

        }

        },
        error: function(error) {

        var error = JSON.parse(error.responseText);

        $(".productsErrorMessage").html(error.description);

        if($(".variant-item-error").length) {

        scrollTo($(".variant-item-error:first"));
        } else {

        $(".productsErrorMessage").removeClass("visually-hidden")
        scrollTo($(".productsErrorMessage"));
        }

        },
        complete: function() {

        $button.removeClass("processing");

        }
        });
        }
        function resetVariantsForms($container) {

        if(typeof $container !== "undefined") {

        $container.find("input.variant-quantity").val(0);

        $container.find(".price-view-details-container").addClass("visually-hidden");  
        $container.find(".product-total").html(formatMoney("0" , getMoneyFormat()));
        $container.find(".clear-line").addClass("visually-hidden");
        $container.find(".product-line-price-details").html("");
        $container.find(".variant-quantity").removeClass("quantity-error");
        $container.find(".secondary-details").removeClass("quantity-error");
        $container.find(".variant-item").removeClass("variant-item-error");
        $container.removeClass("productitem-error");

        $container.find(".inventory-error").addClass("visually-hidden");

        $container.find(".product-compare-at-total").html(formatMoney("0" , getMoneyFormat())).addClass("visually-hidden"); 


        } else {

        $("input.variant-quantity").val(0);

        $(".price-view-details-container").addClass("visually-hidden");  
        $(".product-total").html(formatMoney("0" , getMoneyFormat()));
        $(".clear-line").addClass("visually-hidden");
        $(".product-line-price-details").html("");

        $(".variant-quantity").removeClass("quantity-error");
        $(".secondary-details").removeClass("quantity-error");   
        $(".inventory-error").addClass("visually-hidden");
        $(".variant-item").removeClass("variant-item-error");
        $(".productitem").removeClass("productitem-error");

        $(".product-compare-at-total").html(formatMoney("0" , getMoneyFormat())).addClass("visually-hidden"); 
        }	    
        }
        function updateSelectedItems() {

        let total = 0;
        let $selectedProducts = $('input.variant-quantity').filter(function() {
        return parseInt($(this).val(), 10) > 0;
        });


        for(let i=0; i < $selectedProducts.length; i++) {

        let qty = $($selectedProducts[i]).val();

      qty = parseInt(qty) || 0;
      total += qty;

    }
                   if(total > 0) {

      $(".items-selected").html(`<span class="selected-items-count">${total}</span>&nbsp;<span class="selected-items-message">items selected</span>`);

    } else {

      $(".items-selected").html("");
    }

  }


  function updateProductLineTotal($quantityInput) {

    let $productVariants = $quantityInput.closest("ul.product-variants");

    let $selectedProducts = $productVariants.find('input.variant-quantity').filter(function() {
      return parseInt($(this).val(), 10) > 0;
    });


    if($selectedProducts.length) {

      let lineTotal = 0;
      let lineCompareAtTotal = 0;
      let variantPriceHtml = `<ul class="variant-price-details">`;

      for(let i=0; i <  $selectedProducts.length; i++) {

        let $selectedProduct = $($selectedProducts[i]);

        let quantity = parseInt($selectedProduct.val()) || 0;
        let variant_id = $selectedProduct.data("variant-id");
        let $variantItem = $(".variant-item[data-variant-id='"+variant_id+"']");
        let $variantData = $variantItem.find(".variant-details-data").html();
        let variant = JSON.parse($variantData) || [];
        if(variant && Object.keys(variant).length) {
          lineTotal += variant.price*quantity;

          if(variant.compare_at_price) {

            lineCompareAtTotal += variant.compare_at_price*quantity;
          }

        }    	
      } 

      $quantityInput.closest(".productitem").find(".product-total").html(formatMoney(lineTotal , getMoneyFormat()));

      if(lineCompareAtTotal >  lineTotal) {

        $quantityInput.closest(".productitem").find(".product-compare-at-total").html(formatMoney(lineCompareAtTotal , getMoneyFormat())).removeClass("visually-hidden");      

      } else {

        $quantityInput.closest(".productitem").find(".product-compare-at-total").addClass("visually-hidden");

      }

    }

  }

  function updateCartItemsCount() {

    jQuery.ajax({
      type: 'get',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart){

        onCartUpdate(cart);

      },
      error:function(error) {

        console.log(error);
      }
    });
  }
  function updateProductLineTotals($quantityInput) {

    let $productVariants = $quantityInput.closest("ul.product-variants");

    let $selectedProducts = $productVariants.find('input.variant-quantity').filter(function() {
      return parseInt($(this).val(), 10) > 0;
    });


    if($selectedProducts.length) {

      let lineTotal = 0;
      let lineCompareAtTotal = 0;
      let variantPriceHtml = `<ul class="variant-price-details">`;

      for(let i=0; i <  $selectedProducts.length; i++) {

        let $selectedProduct = $($selectedProducts[i]);

        let quantity = parseInt($selectedProduct.val()) || 0;
        let variant_id = $selectedProduct.data("variant-id");
        let $variantItem = $(".variant-item[data-variant-id='"+variant_id+"']");
        let $variantData = $variantItem.find(".variant-details-data").html();
        let variant = JSON.parse($variantData) || [];
        if(variant && Object.keys(variant).length) {
          lineTotal += variant.price*quantity;

          if(variant.compare_at_price) {

            lineCompareAtTotal += variant.compare_at_price*quantity;
          }

          let variant_title = variant.title === "Default Title"  ? variant.name :variant.title;

          variantPriceHtml += `<li>
<p>${variant_title}&nbsp;( ${formatMoney(variant.price , getMoneyFormat())} ) X ${$quantityInput.val()}</p>
</li>`;
        }    	
      } 

      variantPriceHtml += "</ul>";

      $quantityInput.closest(".productitem").find(".price-view-details-container").removeClass("visually-hidden");  
      $quantityInput.closest(".productitem").find(".product-total").html(formatMoney(lineTotal , getMoneyFormat()));

      if(lineCompareAtTotal >  lineTotal) {

        $quantityInput.closest(".productitem").find(".product-compare-at-total").html(formatMoney(lineCompareAtTotal , getMoneyFormat())).removeClass("visually-hidden");      

      } else {

        $quantityInput.closest(".productitem").find(".product-compare-at-total").addClass("visually-hidden");

      }


      $quantityInput.closest(".productitem").find(".clear-line").removeClass("visually-hidden");
      $quantityInput.closest(".productitem").find(".product-line-price-details").html(variantPriceHtml);

    } else {

      $quantityInput.closest(".productitem").find(".price-view-details-container").addClass("visually-hidden");  
      $quantityInput.closest(".productitem").find(".product-total").html(formatMoney("0" , getMoneyFormat()));
      $quantityInput.closest(".productitem").find(".product-compare-at-total").html(formatMoney("0" , getMoneyFormat()));
      $quantityInput.closest(".productitem").find(".clear-line").addClass("visually-hidden");
      $quantityInput.closest(".productitem").find(".product-line-price-details").html("");

    }

  }


  $(window).on('scroll', function() { 

    if($('.productlistview--items').length) {

      if ($(window).scrollTop() >= $( 
        '.productlistview--items').offset().top + $('.productlistview--items'). 
          outerHeight() - window.innerHeight) { 

        $(".products-list-footer").addClass("stick-to-products-list");
      } else {

        $(".products-list-footer").removeClass("stick-to-products-list");

      }
    }

  });


  $(document).on("click", ".cart-item--remove-link", function(e) {

    e.preventDefault();

    let $cartItem = $(this).closest(".productgrid--item");

    var data = {
      quantity: 0,
      id: $cartItem.data("variant-id")
    }
    updateCartLine($cartItem, data);

  });

  $(document).on('click', '.js-ajax-remove-upsell-product', function(e) {

    e.preventDefault();

    let data = {
      quantity: 0,
      id: $(this).data("variant-id")
    };

    let $this = $(this);

    jQuery.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function(cart){

        fetchCart();

        if( $this.closest('.upsell-item ').length > 0 ) {
          $this.closest( '.upsell-item' ).removeClass( 'itemInCart' );
        }
      },
      error:function(error) {

        console.log(error);
      }
    });
  });

  function updateCartLine($cartItem, data) {
    jQuery.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function(cart){

        if(data.quantity === 0) {
          $cartItem.remove();
        }

        if(cart.item_count === 0) {
          window.location.reload();
        }
        $(".cart-subtotal span.money").html(formatMoney(cart.total_price , getMoneyFormat()));
        updateCartItemsCount();

        let cartCountsHtml = "[";
        let items = (cart.item_count == 0 || cart.item_count > 1) ? "items" : "item";
        cartCountsHtml += cart.item_count +" "+items;
        cartCountsHtml += "]";
        $(".cart-title .cart-count").html(cartCountsHtml);

        updateFreeGiftsLevel();window.location.reload();},
      error:function(error) {
        console.log(error);
      }
    });
  }


  function freeGiftAndRewards(currentamount) {
    var targetamount = 0;
    if(currentamount > 500000) {
      targetamount = 1000000;
    } else if(currentamount > 400000) {
      targetamount = 500000;
    } else if(currentamount > 200000) {
      targetamount = 400000;
    } else if(targetamount > 100000) {
      targetamount = 200000;
    } else if(targetamount > 75000) {
      targetamount = 100000;
    } else if(targetamount > 50000) {
      targetamount = 75000;
    }else if(targetamount > 20000) {
      targetamount = 50000;
    } else {
      targetamount = 20000;
    }

    // Call free gifts based on cart amount
    handleFreeGifts(currentamount); 
    //targetamount = (currentamount > 50000 && currentamount < 75000 ) ? 75000:  targetamount;
    var level = (currentamount/targetamount)*100;
    level = level.toFixed(2);
    
    if(level > 100){ level = 100; }
    let amountToCompare = targetamount-currentamount;// > 0 ? targetamount-currentamount : 50000 - currentamount;

    if((targetamount-currentamount > 0) || targetamount < 50000 ) {

      let nextLevelAmount = currentamount > targetamount ? currentamount - targetamount : targetamount - currentamount;
      
      $('.reward-strip .currentamount').text('$'+((nextLevelAmount)/100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
      if(targetamount > 50000){ $('.reward-strip .targetamount').text('the next level'); }else{ $('.reward-strip .targetamount').text('your free gift'); }
    } else {
      $(".reward-strip p").html("Congratulations! you are eligible for free gift.");
    }
    $('.reward-strip .pbar').css({'width': level+'%'});
    }

    function updateFreeGiftsLevel() {
      $.getJSON('/cart.js', function(cart){
        var currentamount = cart.total_price;

        // Call free gifts and rewards based on cart amount
        freeGiftAndRewards(currentamount);

      });
    }


    function initFreeGiftSlider() {

      let $productgridFreeGift =     $('.productgrid--free-gift-items');
      if ($productgridFreeGift.hasClass('slick-initialized')) {
        $productgridFreeGift[0].slick.unslick()
      }
      $productgridFreeGift.slick({
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }

        ]
      });
    } 

    $(function() {
      if(currenturl.includes("/cart") || currenturl.includes("loyalty-rewards-program")) {
        updateFreeGiftsLevel();
      }

        var tags = window.product_tags || [];
        
        if($(".product-variants-form-custom").length && tags.length) {

          var tiers = {};
        $(tags).each(function(index) {
        var tag = tags[index];
        if(tags != undefined){
        var arr = tag.split("-");
        if(arr[0] === "quantity"&& arr.length === 5){
        var key = parseInt(arr[1]);
        arr.push($(this));
        tiers[key] = arr;
        }
        }
        });
        
        var keys_string = Object.keys(tiers);
        if (keys_string.length >= 1) { 
        /* 
         * Tiers are only specified in tags from the first quantity amount that we start offering discounts at. 
         * So, we need to add add another tiers dynamically from qty 1 to the first quantity we offer discounts at 
        */
        var keys = [];
        for(var i = 0; i < keys_string.length; i++) {
          keys.push(parseInt(keys_string[i]));
        }
        bubbleSort(keys);
        /*
        tiers["1"] = [
          "quantity",
          "1",
          (keys[0]-1).toString(), 
          "discount",
          "0"
        ];
        */
        
        }

      var tiersLength = Object.keys(tiers).length;
      if(tiersLength) {
      
      $("th.variant-quantity").attr("colspan", tiersLength+1);
      
      for (let quantity in tiers) {
        $(".variant-quantity-wrapper").append(`<td>${quantity}+</td>`);
      }
      
      let variantPriceItems = $(".variant-price-item");
      
      for (let i=0; i < variantPriceItems.length; i++) {
      
      let $variantPriceItem = $(variantPriceItems[i]);
      
      let variantPriceItemPrice =  $variantPriceItem.data("price");
      variantPriceItemPrice = parseInt(variantPriceItemPrice, 10);
      
       for (let quantity in tiers) {
      let tier = tiers[quantity];
      let discountAmount =  tier[4];  
      
      let variantPriceItemPriceFormatted = "";
      
      let discountAmountValue = Math.floor((discountAmount)*100);
      
      let variantPriceItemPriceDiscounted = variantPriceItemPrice - discountAmountValue;
      
      variantPriceItemPriceDiscounted = variantPriceItemPriceDiscounted < 0 ? variantPriceItemPrice : variantPriceItemPriceDiscounted;
      
      variantPriceItemPriceFormatted =  formatMoney(variantPriceItemPriceDiscounted , getMoneyFormat());
      
      
      let $variantPriceLastItem = $variantPriceItem.closest(".variants-content").find(".variant-price:last");
      
      if($variantPriceLastItem.length) {
      
      $(`<td class="variant-price"">${variantPriceItemPriceFormatted}</td>`).insertAfter($variantPriceLastItem);
      
      } else { 
      $(`<td class="variant-price"">${variantPriceItemPriceFormatted}</td>`).insertAfter($variantPriceItem);
      }
         }
      
      }
      }
      }
    });
    function bubbleSort(items) {
          var length = items.length;
          for (var i = 0; i < length; i++) { //Number of passes
          for (var j = 0; j < (length - i - 1); j++) { //Notice that j < (length - i)
          //Compare the adjacent positions
          if(items[j] > items[j+1]) {
          //Swap the numbers
          var tmp = items[j];  //Temporary variable to hold the current number
          items[j] = items[j+1]; //Replace current number with adjacent number
          items[j+1] = tmp; //Replace adjacent number with current number
          }
          }        
          }
          }
    function handleFreeGifts(cartTotal) {

      let cartAmount = parseFloat(cartTotal/100).toFixed(2);
      let freeGiftsProductType = "";

      if(cartAmount >= 200 && cartAmount < 500) {

        freeGiftsProductType = "free 200";
      }
      if(cartAmount >= 500 && cartAmount < 750) {

        freeGiftsProductType = "free 500";
      }
      if(cartAmount >= 750 && cartAmount < 1000) {

        freeGiftsProductType = "free 750";
      }
      if(cartAmount >= 1000 && cartAmount < 2000) {

        freeGiftsProductType = "free 1000";
      }
      if(cartAmount >= 2000 && cartAmount < 4000) {

        freeGiftsProductType = "free 2000";
      }
      
      if(cartAmount >= 4000 && cartAmount < 5000) {
      
      freeGiftsProductType = "free 4000";
      }
      if(cartAmount >= 5000 && cartAmount < 10000) {
      
      freeGiftsProductType = "free 5000";
      }

      if(cartAmount >= 10000 ) {

        freeGiftsProductType = "free 10000";
      }

      let freeGiftItemLevel = "";
      let $freeGiftData = $('[data-free-gift]');

      if($freeGiftData.length) {
        freeGiftItemLevel = $freeGiftData.data('free-gift-level');
        $(".free-gift-wrapper").css("visibility", "hidden");
      } else {
        $(".free-gift-wrapper").removeAttr("style");
      }

      let freeGiftItemLevelAmount = 0;

      //freeGiftItemLevel = freeGiftItemLevel.replace("free", "").trim();
      //freeGiftItemLevel = parseFloat(freeGiftItemLevel).toFixed(2);

      let variantId = parseInt($freeGiftData.data('cartitem-id'), 10) || 0;
      let anotherGiftVariantId = 0;
      if($freeGiftData.length > 1) {
        anotherGiftVariantId = parseInt($('[data-free-gift]:first').data('cartitem-id'), 10) || 0;
      }
      
      let data = {
        updates: {}
      };
      
      data.updates[variantId] = 0;
      if(anotherGiftVariantId)
        data.updates[anotherGiftVariantId] = 0;

      if((freeGiftItemLevel && freeGiftItemLevel !== freeGiftsProductType) || ($freeGiftData.length > 1)) {

        $.ajax({
          url:"/cart/update.js",
          data: data,
          beforeSend: function() {

          },
          type:'GET',
          success: function(data){
            window.location.reload();
          },
          complete: function() {

          }
        });
      }
      if(freeGiftsProductType && !$('[data-free-gift]').length) {
        let queryString = encodeURIComponent(freeGiftsProductType)+"&view=html";
        let url = '/collections/types?q='+queryString;

        try {

          $.ajax({
          url:url,
          beforeSend: function() {
          },
          type:'GET',
          success: function(data){
            let $html = $(data);
            let $freeGifts = $html.find(".free-gift-items-wrapper").html();
            //$( ".free-gifts-section-container" ).html($(data).find(".free-gift-items-wrapper").html());
            $( ".free-gifts-section-container" ).html(data);
            initFreeGiftSlider();
          },
          complete: function() {


          }
        });
        } catch(e) {
          console.log(e);
        }
        

      }
    }


    window.writeCookie = function(cName,cVal,cExpMin) {
      cExpMin = cExpMin || 0;
      newDate = new Date;
      deleteCookie(cName);
      var date = new Date();
      date.setTime(date.getTime()+(cExpMin*60*1000));
      var expires = "; expires="+date.toGMTString();
      document.cookie = cName+"="+encodeURIComponent(cVal)+";expires="+date.toGMTString()+";path=/; samesite=none; secure"
    }

    window.readCookie = function(cname){
      var name = cname + "=";
      var ca = decodeURI(document.cookie);
      // var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    window.deleteCookie = function(name){
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; samesite=none; secure';
    }


    $(document).on("click", ".reorder-link", function(e) {

      let $this = $(this);

      e.preventDefault();

      let $orderWrapper = $this.closest(".order-wrapper");

      let $orderItems = $orderWrapper.find(".account-page-order-items");

      let orderItemsString = "";

      let data = [];
      for (let i=0; i< $orderItems.length; i++) {

        let $orderItem = $($orderItems[i]);
        let variant_id = parseInt($orderItem.data("variant-id"), 10);

        let $quantityObj = $orderItem.find(".variant-quantity");
        let quantity = $quantityObj.html();
        quantity = parseInt(quantity, 10);


        let inventoryPolicy = $quantityObj.data("inventory-policy");
        let inventoryQuantity = $quantityObj.data("inventory-quantity");

        if(inventoryPolicy == "continue" || (inventoryPolicy == "deny" && quantity < inventoryQuantity)) {

          data.push({

            quantity: quantity,
            id: variant_id

          })

          orderItemsString += `${variant_id}:${quantity}`;


          if(i <$orderItems.length-1) {

            orderItemsString += ",";
          }
        }
      }


      Shopify.clear(function(){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {

            items: data
          },
          beforeSend:  function() {

            $this.closest('.order-wrapper').find(".list-header").addClass("reorder-processing");
            $this.closest('.order-wrapper').find(".loader").removeClass("hide");
          },
          success: function(cart) {

            window.location.href = "/cart";
          },
          error: function(error) {

            var error = JSON.parse(error.responseText);

            console.log(error.description);

            $this.closest('.order-wrapper').find(".list-header").removeClass("reorder-processing");
            $this.closest('.order-wrapper').find(".loader").addClass("hide");

          }
        });
      });



      //let cartLink = "/cart/"+orderItemsString;

      // window.location.href = cartLink;
    });

    $('.variantImage').click(function(){

      let variantOption = $(this).attr("rel");
      let $variantThumb = $(".product-gallery--navigation").find(".variant-"+variantOption);

      if($variantThumb.length) {

        $variantThumb.eq(0).trigger('click');

        $('.option-values .option-value[rel="'+variantOption+'"]').trigger('click');
      }
    }); 


    $(document).ready(function(){

      $('.variant-'+$('.swatches .option-selected').attr('rel')).show();
      $('.swatches .option-value').click(function(){

        $('.product-gallery--media-thumbnail').hide();
        $('.variant-'+$(this).attr('rel')).show();
      });
    });

    $(document).on("click", ".close-upsell-popup", function(e) {

      e.preventDefault();

      $('#upsellPopup').removeClass("show-popup");
      $('body').removeClass('has-upsell-popup');

      if(!$(this).hasClass("close_button")) {window.location.href = "/cart";}
    });

    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    };

    function writeDocCookie(cName,cVal,cExpMin) {
      cExpMin = cExpMin || 0;
      newDate = new Date;
      deleteCookie(cName);
      var date = new Date();
      date.setTime(date.getTime()+(cExpMin*60*1000));
      var expires = "; expires="+date.toGMTString();
      document.cookie = cName+"="+encodeURIComponent(cVal)+";expires="+date.toGMTString()+";path=/; samesite=none; secure"
    }

    function readDocCookie(cname){
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function deleteDocCookie(name){
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; samesite=none; secure';
    }
    $(function() {    
      (function() {
        // CHANGE THIS SELECTOR to the element you want to add your custom switcher to.
        let weglotLanguageContainer = document.getElementById("weglot-language-container");
        let weglot_language_shown = !!readDocCookie("weglot_language_shown");


        if (!Weglot || weglot_language_shown) {
          return;
        }

        // Create array of options to be added
        var availableLanguages = Weglot.options.languages;

        if(typeof availableLanguages !== "undefined" && availableLanguages) {
          availableLanguages = availableLanguages.map(function(language) {
            return language.language_to;
          }).concat(Weglot.options.language_from);

          availableLanguages = availableLanguages.sort();

          var languageList = document.createElement("ul");
          weglotLanguageContainer.appendChild(languageList);
          $(".weglot-language-modal-wrapper").removeClass("no-content");
          var currentLang = Weglot.getCurrentLang();

          for (let i = 0; i < availableLanguages.length; i++) {
            let lang = availableLanguages[i];
            let li = document.createElement("li");

            $(li).addClass("language-option");
            $(li).attr('data-lang', lang);

            let classValue = "";
            let languageHtml = `<h2 class="no-translate">Welcome</h2><p class="no-translate">Choose your language : `+Weglot.getLanguageName(lang)+`</p><span data-lang="${lang}" class="flag flag-${lang}"></span>`;
            if(lang == "fr"){
              languageHtml = `<h2 class="no-translate">Bienvenue</h2><p class="no-translate">Sélectionnez la langue voulue : `+Weglot.getLanguageName(lang)+`</p><span data-lang="${lang}" class="flag flag-${lang}"></span>`;
            }

            $(li).html(`${languageHtml}`);
            if (lang == currentLang) {

              $(li).addClass(`selected ${i}`);        
            }
            languageList.appendChild(li);

            if(i !== availableLanguages.length - 1) {

              let separatorLi = document.createElement("li");
              $(separatorLi).addClass('separator-container').html(`<div class="separator"><span>OR</span></div>`)
              languageList.appendChild(separatorLi);
            }
          }

          $(document).on("click", ".language-option", function(e) {

            e.preventDefault();
            Weglot.switchTo($(this).data("lang"));

            writeDocCookie("weglot_language_shown",1, 60*24*365);
            $(".weglot-language-modal-wrapper").addClass("visually-hidden");

          });


          Weglot.on("languageChanged", function(lang) {
            $('.language-option').removeClass("selected");
            $('.language-option[data-lang="'+lang+'"]').addClass("selected"); 

          });
        }
      })();
    });

    $(document).on("click", ".weglot-language-modal-close", function(e) {

      e.preventDefault();

      writeDocCookie("weglot_language_shown",1, 60*24*365);
      $(".weglot-language-modal-wrapper").addClass("visually-hidden");

    });